/**
 * Combsol Eyebrow — Spec §2.3
 * Mono, klein, UPPERCASE, mit 32px-Strich links via ::before.
 * Verwendung: Prefix über Headlines, Section-Tags.
 */
import type { CSSProperties, ReactNode } from "react";

interface Props {
  children: ReactNode;
  onDark?: boolean;
  className?: string;
  style?: CSSProperties;
}

export function Eyebrow({ children, onDark = false, className = "", style }: Props) {
  const color = onDark ? "rgba(255,255,255,.75)" : "var(--color-muted, #707372)";
  const stroke = onDark ? "rgba(255,255,255,.5)" : "var(--color-brand-blue, #00A3E0)";
  return (
    <span
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 12,
        fontFamily: "var(--font-mono, 'JetBrains Mono', monospace)",
        fontSize: "0.72rem",
        fontWeight: 500,
        textTransform: "uppercase",
        letterSpacing: "0.18em",
        color,
        lineHeight: 1,
        ...style,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          display: "inline-block",
          width: 32,
          height: 1,
          background: stroke,
        }}
      />
      {children}
    </span>
  );
}
